import { Grid } from '@material-ui/core'
import { ImSad } from 'react-icons/im'
import Modal from 'shared/components/Modal'
import { colors } from 'shared/styles/colors'
import { ELockOCMessageTypes } from '../../utils/ELockOCMessage'
import { ContainerIcon, Message, StyleButton } from './styles'

const MESSAGE =
  'Infelizmente não foi possível gerar a ordem de carga. Isso pode ter acontecido por algumas razões, inclusive porque os dados do motorista ou do veículo podem estar desatualizados.<br><br>Para maiores informações, ligue para <b>(43) 3305-9500.</b><br>Tenha em mãos a placa do cavalo e o CPF do motorista.'

type TProps = {
  openModal?: boolean
  setAlertType?: (arg0: ELockOCMessageTypes) => void
}

const ModalReprovadoGr: React.FC<TProps> = ({ openModal, setAlertType }) => {
  return (
    <>
      <Modal
        openModal={openModal}
        size={'small'}
        showCloseButton={true}
        onCloseModal={() => setAlertType(ELockOCMessageTypes.NENHUM)}
      >
        <Grid
          md={12}
          container
          spacing={2}
          justify="space-between"
          alignItems="center"
          style={{ textAlign: 'center', height: '100%' }}
        >
          <Grid container alignItems="center" justify="center" spacing={4}>
            <Grid item>
              <ContainerIcon>
                <ImSad color={colors.blue} />
              </ContainerIcon>
            </Grid>
          </Grid>

          <Grid container item>
            <Message
              dangerouslySetInnerHTML={{
                __html: `${MESSAGE}`,
              }}
            />
          </Grid>

          <Grid container alignItems="center" justify="center" item>
            <StyleButton
              color={colors.green}
              onClick={() => {
                setAlertType(ELockOCMessageTypes.NENHUM)
              }}
            >
              Entendi
            </StyleButton>
          </Grid>
        </Grid>
      </Modal>
    </>
  )
}

export default ModalReprovadoGr
